import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { adminIsAuthed, adminLogout, adminMe } from "../../lib/api";

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("admin_email") || "");

  useEffect(() => {
    if (!adminIsAuthed()) {
      navigate("/admin/login", { replace: true });
      return;
    }
    adminMe()
      .then((u) => {
        setEmail(u.email || "");
        setReady(true);
      })
      .catch(() => {
        adminLogout();
        navigate("/admin/login", { replace: true });
      });
  }, [navigate]);

  function onLogout() {
    adminLogout();
    navigate("/admin/login", { replace: true });
  }

  if (!ready) {
    return (
      <main
        data-testid="admin-loading"
        className="min-h-screen bg-[color:var(--bg)] text-white flex items-center justify-center"
      >
        <span className="font-serif-display italic text-white/45">Loading…</span>
      </main>
    );
  }

  const link = ({ isActive }) =>
    `block px-4 py-2 text-sm font-serif-display italic rounded-md border ${
      isActive
        ? "text-white bg-white/[0.06] border-white/20"
        : "text-white/60 hover:text-white border-transparent hover:border-white/10"
    }`;

  return (
    <div
      data-testid="admin-layout"
      className="min-h-screen bg-[color:var(--bg)] text-white"
    >
      <aside className="fixed top-0 bottom-0 left-0 w-56 border-r border-white/10 bg-black/40 backdrop-blur px-4 py-8 flex flex-col">
        <div className="mb-8">
          <h2 className="font-serif-display italic text-lg text-white/85" data-testid="admin-title">
            Admin
          </h2>
          <p className="mt-1 text-[11px] uppercase tracking-[0.22em] text-white/35 font-serif-display italic">
            Carol Lines Photography
          </p>
        </div>
        <nav className="space-y-1">
          <NavLink to="/admin/photographs" className={link} data-testid="admin-nav-photographs">
            Photographs
          </NavLink>
          <NavLink to="/admin/relationships" className={link} data-testid="admin-nav-relationships">
            Questions
          </NavLink>
          <NavLink to="/admin/submissions" className={link} data-testid="admin-nav-submissions">
            Enquiries
          </NavLink>
          <NavLink to="/admin/health" className={link} data-testid="admin-nav-health">
            Health
          </NavLink>
          <NavLink to="/admin/password" className={link} data-testid="admin-nav-password">
            Password
          </NavLink>
        </nav>
        <div className="mt-auto text-xs text-white/40 font-serif-display italic space-y-2">
          <p className="truncate" data-testid="admin-email">{email}</p>
          <button
            type="button"
            onClick={onLogout}
            data-testid="admin-logout"
            className="text-left hover:text-white/80"
          >
            Sign out
          </button>
          <a href="/" className="block hover:text-white/80 pt-2 border-t border-white/[0.06]">
            View public site →
          </a>
        </div>
      </aside>
      <main className="pl-56 min-h-screen">
        <div className="max-w-5xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
